import {
  Autocomplete,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";

function ListaProductos({
  productos,
  todosProductos,
  setTodosProductos,
  productosSeleccionados,
  setProductosSeleccionados,
}) {
  const [productoInput, setProductoInput] = useState("");
  const [filtroProductos, setFiltroProductos] = useState("");

  const productosDisponibles = productos.filter(
    (p) => !productosSeleccionados.some((pp) => pp.idproducto === p.idproducto)
  );

  const productosFiltrados = productosSeleccionados.filter((p) =>
    p.nombre.toLowerCase().includes(filtroProductos.toLowerCase())
  );

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);

  const handleToggleTodosProductos = (event) => {
    const checked = event.target.checked;
    setTodosProductos(checked);

    if (checked) {
      // Solo selecciono los que NO están en precioEspecial
      const filtrados = productos.filter(
        (p) => !productosDisponibles.includes(p.idproducto)
      );
      setProductosSeleccionados(filtrados);
    } else {
      setProductosSeleccionados([]);
    }
  };
  const handleAgregarProducto = (producto) => {
    if (
      producto &&
      !productosSeleccionados.some((p) => p.idproducto === producto.idproducto)
    ) {
      setProductosSeleccionados((prev) => [...prev, producto]);
      setProductoInput("");
      // Si se agrega manualmente un producto, desmarcar "Todos"
      if (todosProductos) {
        setTodosProductos(false);
      }
    }
  };

  const eliminarProducto = (id) => {
    const nuevosProductos = productosSeleccionados.filter(
      (p) => p.idproducto !== id
    );
    setProductosSeleccionados(nuevosProductos);

    // Si no hay productos seleccionados, marcar "Todos" como false
    if (nuevosProductos.length === 0) {
      setTodosProductos(false);
    }

    // Si se eliminó alguno, ya no están todos seleccionados
    if (todosProductos) {
      setTodosProductos(false);
    }
  };
  
  return (
    <>
      <Grid container>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={todosProductos}
                onChange={handleToggleTodosProductos}
              />
            }
            label="Todos los Productos"
          />
        </Grid>
        <Grid item xs={8}>
          <Autocomplete
            size="small"
            disabled={todosProductos}
            options={productosDisponibles}
            getOptionLabel={(p) => p.nombre}
            value={null}
            inputValue={productoInput}
            onInputChange={(_, value) => setProductoInput(value)}
            onChange={(_, value) => handleAgregarProducto(value)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Agregar producto"
                placeholder="Buscar..."
              />
            )}
          />
        </Grid>
      </Grid>

      <Box
        mt={1}
        sx={{
          border: "1px solid #ccc",
          borderRadius: "5px",
          padding: "10px",
          backgroundColor: "#f9f9f9",
          height: 150,
          overflowY: "auto",
        }}
      >
        <Box
          mb={0.5}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography fontWeight="bold" color="#1F618D">
            Productos Seleccionados:
          </Typography>
          <TextField
            size="small"
            placeholder="Buscar..."
            value={filtroProductos}
            onChange={(e) => setFiltroProductos(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ width: "50%" }}
          />
        </Box>

        {productosFiltrados.length > 0 ? (
          productosFiltrados.map((p) => (
            <Box
              key={p.idproducto}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              // mb={0.5}
              borderTop={1} // Borde de 1px
              borderColor="divider" // Usa el color de tema 'divider'
              pt={1} // Padding top
              sx={{
                "&:first-of-type": {
                  borderTop: "none", // Sin borde para el primer elemento
                },
              }}
            >
              <Typography variant="body2">• {p.nombre}</Typography>
              <IconButton
                size="small"
                onClick={() => eliminarProducto(p.idproducto)}
              >
                <DeleteIcon fontSize="small" color="error" />
              </IconButton>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">
            {filtroProductos
              ? "No hay coincidencias"
              : "No hay productos seleccionados"}
          </Typography>
        )}
      </Box>
    </>
  );
}

export default ListaProductos;
